import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "./api";

export const RISK = {
  late: ["Late", "bg-rose-100 text-rose-700"],
  blocked: ["Blocked", "bg-amber-100 text-amber-800"],
  at_risk: ["At risk", "bg-orange-100 text-orange-700"],
  on_track: ["On track", "bg-emerald-100 text-emerald-700"],
  not_planned: ["No steps yet", "bg-muted text-muted-foreground"],
  done: ["Delivered", "bg-sky-100 text-sky-700"],
};
export const TONE = {
  not_started: "bg-muted text-muted-foreground", wip: "bg-sky-100 text-sky-700", blocked: "bg-amber-100 text-amber-800",
  hold: "bg-zinc-200 text-zinc-700", qc_pending: "bg-violet-100 text-violet-700", done: "bg-emerald-100 text-emerald-700",
  cancelled: "bg-zinc-100 text-zinc-500 line-through",
};
export const OPEN = ["not_started", "wip", "blocked", "hold", "qc_pending"];
export const COMPANY = { DEL: "Delhi (FBD)", MUM: "Mumbai" };
export const inp = "bg-muted/60 border h-10 px-2 text-sm w-full";
export const sentForApproval = (r) => {
  if (!r?.data?.pending_request) return false;
  toast.success("Sent for approval", { description: "Mumbai plan changes apply once the Managing Partner or a founder approves." });
  return true;
};
export const btn = "bg-primary text-primary-foreground h-10 px-4 text-sm disabled:opacity-50";
export const btn2 = "border h-10 px-3 text-sm hover:border-primary disabled:opacity-50 whitespace-nowrap";

export const Pill = ({ tone, children, tid }) => (
  <span data-testid={tid} className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap ${tone}`}>{children}</span>
);
export const RiskPill = ({ r, tid }) => <Pill tone={(RISK[r] || RISK.not_planned)[1]} tid={tid}>{(RISK[r] || RISK.not_planned)[0]}</Pill>;
export const Field = ({ label, children }) => (
  <label className="block text-xs"><span className="ax-label">{label}</span><div className="mt-1">{children}</div></label>
);
export const fmtD = (s) => {
  if (!s) return "—";
  const x = new Date(`${s.slice(0, 10)}T00:00:00`);
  return x.toLocaleDateString("en-IN", { day: "numeric", month: "short", ...(x.getFullYear() !== new Date().getFullYear() && { year: "numeric" }) });
};
export const pct = (v) => (v === null || v === undefined ? "—" : `${v}%`);

export const useOpsMeta = () => {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/ops/meta").then((r) => setM(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  return m;
};

export const useLoad = (url) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => api.get(url).then((r) => { setD(r.data); setErr(null); }).catch((e) => setErr(e)), [url]);
  useEffect(() => { load(); }, [load]);
  return [d, load, err];
};
